/**
 * 포럼 댓글 카테고리 규칙 SSOT (JCG-3603).
 *
 * 포럼(`forum/{problemId}`)은 잡담(`chat`)을 쓰지 않는다 — 탭은 질문·버그·제안 3개뿐이다.
 * 그런데 `/api/cron/reclassify-comments` 가 slug 를 가리지 않고 "확실하지 않으면 chat" 규칙으로
 * 포럼 댓글을 chat 으로 강등해 화면에서 사라지는 결함이 있었다(2026-09-18 운영 129건 확인).
 *
 * - 표시: `resolveForumCommentCategory` — bug/suggestion 외(chat·null·미지원)는 모두 질문 탭으로 본다.
 * - 크론: `guardForumCategory` — 포럼 댓글에 포럼 탭 밖 카테고리를 제안하면 변경하지 않는다(null).
 */
import type { CommentCategory } from "@/lib/types";
import { isForumCommentSlug } from "@/lib/comment-links";

/** 포럼이 탭으로 노출하는 카테고리(순서 포함). */
export const FORUM_COMMENT_CATEGORIES: readonly CommentCategory[] = [
  "question",
  "bug",
  "suggestion",
];

/** 포럼 댓글의 표시 카테고리. `bug`/`suggestion` 만 그대로, 나머지(chat·null·알 수 없음)는 `question`. */
export function resolveForumCommentCategory(
  category: string | null | undefined,
): CommentCategory {
  return category === "bug" || category === "suggestion" ? category : "question";
}

/**
 * 재분류 크론 가드. 포럼 댓글에 포럼 탭 밖 카테고리(chat)를 제안하면 `null`(변경 없음)을 돌려주고,
 * 그 외에는 제안 그대로 돌려준다. 포럼이 아닌 slug 는 제한하지 않는다.
 */
export function guardForumCategory(
  slug: string | null | undefined,
  proposed: CommentCategory,
): CommentCategory | null {
  if (slug && isForumCommentSlug(slug) && !FORUM_COMMENT_CATEGORIES.includes(proposed)) {
    return null;
  }
  return proposed;
}
